import { defineMessages } from 'react-intl';

export const downloadsCardMessages = defineMessages({
  Header: {
    id: 'downloadsCard.header',
    defaultMessage: 'Downloads',
  },
});
